import { render, staticRenderFns } from "./DetailTicketSponsor.vue?vue&type=template&id=7563aaf8&scoped=true&"
import script from "./DetailTicketSponsor.vue?vue&type=script&lang=js&"
export * from "./DetailTicketSponsor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7563aaf8",
  null
  
)

export default component.exports